import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { PRIMARY_COLORS, PRIMARY_SILVER_COLOR } from '../../../themes/light';

const CELL_PADDING = '4px 16px';
const CELL_HEIGHT = 94;

export const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(even)': {
    backgroundColor: PRIMARY_COLORS.PRIMARY_WHITE,
    '&:hover': {
      backgroundColor: PRIMARY_SILVER_COLOR[300],
    },
  },
  '&:nth-of-type(odd)': {
    backgroundColor: PRIMARY_SILVER_COLOR[200],
    '&:hover': {
      backgroundColor: PRIMARY_SILVER_COLOR[300],
    },
  },
});

export const StyledTableCell = styled(TableCell)({
  padding: CELL_PADDING,
  height: CELL_HEIGHT,
});
